"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @module BryxApi */
var spoonClient_1 = require("../../spoonClient");
var models_1 = require("../../models");
/**
 * Mixin class for callback functions.
 */
var CallbackMixin = /** @class */ (function () {
    function CallbackMixin() {
    }
    /**
     * Sets onUnauthenticated function.
     * @param onUnauthenticated
     */
    CallbackMixin.prototype.setOnUnauthenticated = function (onUnauthenticated) {
        this.onUnauthenticated = onUnauthenticated;
    };
    /**
     * Wraps callback to divert
     * to different function if unauthenticated.
     * @param callback
     * @return Wrapped callback
     */
    CallbackMixin.prototype.unauthenticatedCallback = function (callback) {
        var _this = this;
        return function (request, response) {
            if (response.status == spoonClient_1.ResponseStatus.Unauthorized
                && _this.onUnauthenticated != null) {
                _this.onUnauthenticated();
            }
            callback(request, response);
        };
    };
    /**
     * Wraps callback to receive the correctly parsed
     * response on both success and failure.
     * @TODO Figure out how to initialize what will be replacing bryxLocal. (Callback passed should handle this.)
     * @param request
     * @param response
     * @param callback
     */
    CallbackMixin.prototype.authCallback = function (request, response, callback) {
        if (response.status == spoonClient_1.ResponseStatus.Success) {
            var parseResult = models_1.Auth.parse(response.responseJson);
            if (parseResult.success == true) {
                // BryxLocal.initializeFromAuthModel(parseResult.value);
                callback(this.apiSuccess(parseResult.value));
            }
            else {
                // callback((this as any).apiFailure<AuthModel>(null, parseResult.justification));
                callback(this.apiFailure(null, parseResult.justification));
            }
        }
        else {
            // callback((this as any).apiFailureWithResponse<AuthModel>(response));
            callback(this.apiFailureWithResponse(response));
        }
    };
    return CallbackMixin;
}());
exports.default = CallbackMixin;
//# sourceMappingURL=CallbackMixin.js.map